import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { AdministrationService, AdministrationUser } from '../../../services/administration/administration.service';
import { hasRole } from '../../../guards/auth/roles';
import { RoleDialogComponent } from './role-dialog.component';

@Component({
  selector: 'app-manage-users', standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatTableModule],
  templateUrl: './manage-users.component.html', styleUrl: './manage-users.component.css'
})
export class ManageUsersComponent implements OnInit {
  users: AdministrationUser[] = [];
  query = '';
  loading = true;
  error = '';
  displayedColumns = ['displayName', 'userId', 'roles', 'actions'];
  private activeDialogRef?: MatDialogRef<RoleDialogComponent>;

  constructor(private service: AdministrationService, private dialog: MatDialog, private router: Router, private cdr: ChangeDetectorRef) {}
  ngOnInit(): void { this.load(); }
  get filteredUsers(): AdministrationUser[] {
    const query = this.query.trim().toLocaleLowerCase('da');
    return this.users.filter(user => !query || `${user.displayName ?? ''} ${user.userId} ${user.userType} ${user.editorStoreIds.join(' ')} ${user.roles.join(' ')} ${(user.otherAssignments ?? []).map(item => `${item.role} ${item.scopeType} ${item.scope ?? ''}`).join(' ')}`.toLocaleLowerCase('da').includes(query));
  }
  assignmentLabel(user: AdministrationUser): string {
    return [
      ...user.editorStoreIds.map(id => `SendoutEditor (butik ${id})`),
      ...(user.otherAssignments ?? []).map(item => `${item.role} (${item.scopeType}: ${item.scope ?? '—'})`),
    ].join(', ');
  }
  load(): void {
    this.loading = true; this.error = '';
    this.cdr.markForCheck();
    this.service.getUsers().subscribe({
      next: users => { this.users = users; this.loading = false; this.cdr.markForCheck(); },
      error: () => { this.error = 'Brugerne kunne ikke hentes.'; this.loading = false; this.cdr.markForCheck(); }
    });
  }
  edit(user: AdministrationUser): void {
    const dialogRef = this.dialog.open(RoleDialogComponent, { data: user, width: '420px', closeOnNavigation: false });
    this.activeDialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((updated?: AdministrationUser) => {
      if (this.activeDialogRef === dialogRef) this.activeDialogRef = undefined;
      if (!updated) return;
      this.users = this.users.map(item => item.id === updated.id ? updated : item);
      this.cdr.markForCheck();
      this.service.refreshMyRoles().subscribe({
        next: ({ roles }) => {
          this.cdr.markForCheck();
          if (!hasRole({ roles }, 'UserManager')) this.router.navigate(['/landing']);
        },
        error: () => { this.cdr.markForCheck(); this.router.navigate(['/access-unavailable']); }
      });
    });
  }

  canLeave(): boolean {
    const dialogRef = this.activeDialogRef;
    if (!dialogRef || dialogRef.getState() !== MatDialogState.OPEN) return true;
    if (!dialogRef.componentInstance.canClose()) return false;
    dialogRef.close();
    return true;
  }
}

export const manageUsersCanDeactivate: CanDeactivateFn<ManageUsersComponent> = component => component.canLeave();
